import React from "react";
import BarChart from "./Barchart";
import "./Rightbar.css";
import "./Rightbar.scss";

const Rightbar = ({ reportData }) => {
  const classData = reportData.class;

  // Shared styles
  const containerStyle = {
    display: "flex",
    flexDirection: "column",
  };

  const chartWrapperStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const rowStyle = {
    display: "flex",
    flexDirection: "row",
    textAlign: "center",
    gap: "20px",
    marginTop: "1rem",
  };

  const blockStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column",

    textAlign: "center",
  };

  // Reusable component
  const ClassBlock = ({ title, value }) => (
    <div style={blockStyle}>
      <p className="Unhealthclass">{title}</p>
      <text
        style={{
          fontFamily: "Montserrat",
          fontSize: "14px",
          fontWeight: 500,
        }}
      >
        {value?.length <= 3 ? `CLASS ${value}` : value}
      </text>
    </div>
  );

  return (
    <div style={containerStyle}>
      <div style={chartWrapperStyle}>
        <BarChart />
      </div>

      <div style={rowStyle}>
        <ClassBlock
          title="HEALTHIEST CLASS"
          value={classData?.high_performing_class}
        />
        <ClassBlock
          title="UNHEALTHIEST CLASS"
          value={classData?.low_performing_class}
        />
      </div>
    </div>
  );
};

export default Rightbar;
